export enum WorkPlanStatusEnum {
  SUBMITTED = "SUBMITTED",
  OBSERVATION = "OBSERVATION",
  RESOLVED = "RESOLVED",
  AUTHORIZED = "AUTHORIZED",
  DONE = "DONE",
  FINISHED = "FINISHED",
}

export interface IWorkPlan {
  id?: string | number;
  start_date?: string;
  end_date?: string;
  start_time?: string;
  end_time?: string;
  impact_axis?: string;
  general_objective?: string;
  goal?: string;
  strategy?: string;
  audience?: string;
  scope?: string;
  total_budget?: number;
  status: WorkPlanStatusEnum;
  budget?: string;
  budget_items?: Array<{
    supply_name: string;
    quantity: number;
    unit_cost: number;
    total_cost: number;
    requires_support: boolean | number;
  }>;
  budget_url?: string;
  observation?: string;
}
